module.exports = __webpack_public_path__ + "img/support@2x.c1b25ce5.png";